import LegalDocument from "../Components/LegalDocument";

const PrivacyPolicyPage = () => (
    <LegalDocument type="privacy" introduction={
        <>
            <p>Edu Connekt (“we”, “our”, “us”) is committed to protecting the privacy and security of users (“you”, “your”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our platform.</p>
        </>
    }>
                        <div className="content_box">
                            <h3>1. Scope of Policy</h3>
                            <div className="box_item">
                                <p>This policy applies to:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Website users</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Mobile application users</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Schools, teachers, students, and parents using the platform</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>2. Information We Collect</h3>
                            <div className="sub_item_sec">
                                <div className="sub_box">
                                    <h4>2.1 Personal Information</h4>
                                    <div className="sub_box_item">
                                        <p>We may collect:</p>
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Name, email address, phone number</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Profile details (photo, designation, class details)</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Login credentials (encrypted)</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>2.2 Student Data (Sensitive)</h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Attendance records</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Academic performance, marks, report cards</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Behavioral or disciplinary records</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Health-related basic information (if provided by school)</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>2.3 Technical & Usage Data</h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>IP address</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Browser type, device information</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Login time, activity logs</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Location data (if enabled)</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>2.4 Payment Information</h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Billing details</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Transaction history
                                                (Note: Payment data is processed securely via third-party payment gateways)</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>3. How We Use Your Information</h3>
                            <div className="box_item">
                                <p>We use collected data to:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Provide and operate the platform</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Manage school administration and communication</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Generate reports, analytics, and insights</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Send notifications (SMS, email, app alerts)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Improve performance, security, and user experience</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Comply with legal obligations</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>4. Legal Basis for Processing</h3>
                            <div className="box_item">
                                <p>We process data based on:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Consent (user / institution approval)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Contractual necessity (service delivery)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Legal compliance (as per Indian law)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Legitimate interest (platform improvement, security)</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>5. Data Sharing & Disclosure</h3>
                            <div className="box_item">
                                <p>We do NOT sell personal data.</p>
                                <p>We may share data with:</p>
                            </div>
                            <div className="sub_item_sec">
                                <div className="sub_box">
                                    <h4>5.1 Institution </h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Authorized admins, teachers, and staff can access relevant data</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>5.2 Service Providers </h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Cloud hosting providers (e.g., AWS, Azure)</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>SMS / Email service providers</span></li>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Payment gateways</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>5.3 Legal Authorities</h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>When required by law or court order</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="sub_box">
                                    <h4>5.4 Business Transfers</h4>
                                    <div className="sub_box_item">
                                        <ul>
                                            <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>In case of merger, acquisition, or restructuring</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>6. Data Security Measures</h3>
                            <div className="box_item">
                                <p>We implement industry-standard security:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>End-to-end encryption (where applicable)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Secure APIs and authentication (JWT/OAuth)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Role-based access control (RBAC)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Firewalls and intrusion detection systems</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Regular security audits</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>7. Data Retention Policy</h3>
                            <div className="box_item">
                                <p>We implement industry-standard security:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Data is retained as long as the institution is active</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>After account termination, data may be deleted within 30–90 days</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Backup data may be retained longer for compliance</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>8. User Rights</h3>
                            <div className="box_item">
                                <p>Users (or institutions) have the right to:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Access their personal data</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Request correction or updates</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Request deletion (subject to legal obligations)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Restrict or object to processing</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Withdraw consent</span></li>
                                </ul>
                                <a href="mailto:support@educonnekt.in">Requests can be made via: support@educonnekt.in</a>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>9. Children’s Privacy</h3>
                            <div className="box_item">
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Edu Connekt is used by minors (students)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Schools are responsible for obtaining parental/guardian consent</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>We do not knowingly collect data directly from children without authorization</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>10. Cookies & Tracking Technologies</h3>
                            <div className="box_item">
                                <p>We use cookies and similar technologies to:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Maintain user sessions</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Improve performance and usability</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Analyze traffic and behavior</span></li>
                                </ul>
                                <span>Users can control cookies through browser settings.</span>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>11. Third-Party Services</h3>
                            <div className="box_item">
                                <p>Our platform may integrate with:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Payment gateways</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>SMS/WhatsApp APIs</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Analytics tools</span></li>
                                </ul>
                                <span>These third parties have their own privacy policies, and we are not responsible for their practices.</span>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>12. Cross-Border Data Transfer</h3>
                            <div className="box_item">
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Data may be stored on servers located outside India (e.g., cloud providers)</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>We ensure appropriate safeguards are in place</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>13. Data Breach Notification</h3>
                            <div className="box_item">
                                <p>In case of a data breach:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>We will notify affected institutions/users as required by law</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Immediate steps will be taken to mitigate risks</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>14. Changes to Privacy Policy</h3>
                            <div className="box_item">
                                <p>We may update this Privacy Policy from time to time.</p>
                                <p>Users will be notified via:</p>
                                <ul>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Website notice</span></li>
                                    <li><i aria-hidden="true" className="fa-solid fa-circle"></i><span>Email notification (if applicable)</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>15. Disclaimer</h3>
                            <div className="box_item">
                                <p>While we implement strong security measures, no system is 100% secure. Users share data at their own risk.</p>
                            </div>
                        </div>
                        <div className="content_box">
                            <h3>16. Contact Information</h3>
                            <div className="box_item">
                                <p>Email: <a href="mailto:support@educonnekt.in">support@educonnekt.in</a></p>
                                <p>Phone: <a href="tel:+919449618559">+91 9449618559</a></p>
                                <p>Address: THE MERIDIAN Luxury Hotel, District Stadium Main Road (Kurvangi main road), Dhantaramakki, Chikkamagaluru - 577101, Karnataka, India</p>
                            </div>
                        </div>
    </LegalDocument>
);

export default PrivacyPolicyPage;
